import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowDown2 } from "iconsax-react";
import { memo } from "react";

import type { SelectFieldProps } from "./SelectField.types";
import * as styles from "./SelectField.styles";

export type { SelectFieldProps, SelectFieldOption } from "./SelectField.types";

export const SelectField = memo(function SelectField({
  label,
  options,
  helperText,
  error = false,
  value,
  ...selectProps
}: SelectFieldProps) {
  const theme = useTheme();
  const labelId = `${label}-select-label`;

  // MUI passes the className that positions the icon, flips it when open and lets clicks through.
  const IconComponent = ({ className }: { className?: string }) => (
    <Box className={className} sx={styles.adornment}>
      <ArrowDown2 size={18} variant="Linear" color={theme.palette.text.secondary} />
    </Box>
  );

  return (
    <FormControl fullWidth error={error} sx={styles.root}>
      <InputLabel id={labelId} shrink={Boolean(value)}>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        IconComponent={IconComponent}
        label={label}
        value={value}
        notched={Boolean(value)}
        {...selectProps}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
});
